<template>
  <picture>
    <source
      v-for="{ media, srcsets, type } in sources"
      :key="type + media"
      :media="media"
      :srcset="typeof srcsets === 'string' ? srcsets : srcsets.join(',\n')"
      :type="type"
    >

    <img
      :alt="alt"
      :title="title"
      :src="src"
      :loading="lazyLoad ? 'lazy' : null"
      :width="width"
      :height="height"
    >
  </picture>
</template>

<script>
  export default {
    name: 'ZgImage',
    props: {
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      sources: {
        type: Array,
        default: () => []
      },
      lazyLoad: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: null
      },
      height: {
        type: Number,
        default: null
      }
    }
  }
</script>

<style lang="scss" scoped>
  picture {
    display: contents;
  }

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
</style>
